import { render, staticRenderFns } from "./MonthlyUserNew.vue?vue&type=template&id=57765367"
import script from "./MonthlyUserNew.vue?vue&type=script&lang=js"
export * from "./MonthlyUserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports